import * as React from "react";

import "./expand-all-toggle.scss";

export const ExpandAllToggle = ({onClick}) => (
    <div className="expand-all-toggle expand-all-toggle-9m5">
        <div className="title">
            Paper Type
            <br/>
            <div className="sub-title">
                Expand paper options to compare pricing
            </div>
        </div>
        <div
            className="expand"
            onClick={onClick}
            xd-qa-type="label"
            xd-qa-name="+ Expand All"
        >
            + Expand All
        </div>
    </div>
);